import Dropdown from 'core/elements/dropdown'
import React from 'react'
import { NetworkType } from '../../constants'

const options = [
  { label: 'PRIMARY', value: NetworkType.PRIMARY },
  { label: 'SECONDARY', value: NetworkType.SECONDARY },
]

const ZoneTypePicklist = (props) => {
  return <Dropdown label="Zone Type" items={options} {...props} />
}

export default ZoneTypePicklist
